import Result from './result';

export type CancellableResultDetail = {
  facetecScanStatus?: number;
  facetecScanSessionId?: string | null;
};

export default class CancellableResult<TError extends Error, TSuccess = boolean> extends Result<TError, TSuccess> {
  private cancelled: boolean;

  private detail?: CancellableResultDetail;

  protected constructor(failure?: TError, success?: TSuccess, cancelled?: boolean, detail?: CancellableResultDetail) {
    super(failure, success);
    this.cancelled = cancelled || false;
    this.detail = detail;
  }

  public isCancelled(): boolean {
    return this.cancelled;
  }

  override success(detail?: CancellableResultDetail): TSuccess {
    if (this.cancelled) {
      throw new Error('Cannot return success result of cancelled result');
    }
    this.detail = detail;
    return super.success();
  }

  public static successful<TError extends Error, TSuccess>(
    result: TSuccess,
    detail?: CancellableResultDetail,
  ): CancellableResult<TError, TSuccess> {
    return new CancellableResult<TError, TSuccess>(undefined, result, undefined, detail);
  }

  public static noValueSuccess<TError extends Error>(detail?: CancellableResultDetail): CancellableResult<TError> {
    return new CancellableResult<TError>(undefined, true, undefined, detail);
  }

  public static failed<TError extends Error, TSuccess>(
    failure: TError,
    detail?: CancellableResultDetail,
  ): CancellableResult<TError, TSuccess> {
    return new CancellableResult<TError, TSuccess>(failure, undefined, undefined, detail);
  }

  public static cancelled<TError extends Error, TSuccess>(
    detail?: CancellableResultDetail,
  ): CancellableResult<TError, TSuccess> {
    return new CancellableResult<TError, TSuccess>(undefined, undefined, true, detail);
  }

  public getDetail() {
    return this.detail;
  }
}
